import clsx from "clsx";
import React, { forwardRef } from "react";
import { ArrowDownIcon } from "../../icon/index.js";
import { InputGroup } from "../../input-group/InputGroup.jsx";
import type { SelectProps } from "./types.js";

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
    (props, ref) => {
        const {
            label,
            className,
            errorLabel,
            helpLabel,
            labelProps,
            placeholder = "Velg",
            supportLabelProps,
            tooltip,
            value,
            description,
            ...rest
        } = props;

        const inputGroupProps = {
            label,
            errorLabel,
            helpLabel,
            labelProps,
            supportLabelProps,
            tooltip,
            description,
        };

        return (
            <InputGroup
                {...inputGroupProps}
                data-testid="jkl-select--beta"
                className={clsx("jkl-select--beta", className)}
                render={(inputProps) => (
                    <div className="jkl-select--beta-wrapper">
                        <select
                            ref={ref}
                            defaultValue={value ? undefined : ""}
                            value={value}
                            {...inputProps}
                            {...rest}
                        >
                            {placeholder && (
                                <option disabled selected value="">
                                    {placeholder}
                                </option>
                            )}
                            {props.children}
                        </select>
                        <ArrowDownIcon />
                    </div>
                )}
            />
        );
    },
);
